import React, { forwardRef } from 'react';
import Button from '@components/ui/Button/Button';
import Spinner from '@components/ui/Spinner/Spinner';
import styles from './ActionButtonPair.module.css';

export interface IActionButtonPairProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'onSubmit' | 'onCancel'
> {
  cancelLabel?: string;
  onCancel: () => void;
  cancelDisabled?: boolean;
  submitLabel: string;
  onSubmit: () => void;
  submitDisabled?: boolean;
  isSubmitting?: boolean;
  submitVariant?: 'default' | 'accent';
}

const ActionButtonPair = forwardRef<HTMLDivElement, IActionButtonPairProps>(
  (
    {
      cancelLabel = 'Cancel',
      onCancel,
      cancelDisabled = false,
      submitLabel,
      onSubmit,
      submitDisabled = false,
      isSubmitting = false,
      submitVariant = 'default',
      className,
      ...rest
    },
    ref,
  ) => {
    const accent = submitVariant === 'accent';
    return (
      <div ref={ref} className={`${styles.container} ${className || ''}`} {...rest}>
        <Button
          variant="secondary"
          size="md"
          className={`${styles.pairButton} ${styles.cancel}`}
          onClick={onCancel}
          disabled={cancelDisabled || isSubmitting}
        >
          {cancelLabel}
        </Button>
        <Button
          variant={accent ? 'brand' : 'inverse'}
          size="md"
          className={`${styles.pairButton} ${accent ? styles.submitAccent : styles.submit}`}
          onClick={onSubmit}
          disabled={submitDisabled}
          loading={isSubmitting}
          aria-label={isSubmitting ? submitLabel : undefined}
          spinner={<Spinner size="sm" className={styles.submitSpinner} aria-hidden="true" />}
        >
          {submitLabel}
        </Button>
      </div>
    );
  },
);

ActionButtonPair.displayName = 'ActionButtonPair';

export default ActionButtonPair;
